<template>
  <div>
    <!-- 废弃商品申请 -->
    <baseBreadcrumb :page="$t('message.abandonedGoods')" :menu="$t('message.warehouse')"></baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <el-tabs v-model="datas.status" type="card" @tab-click="handleClick">
        <!-- 全部 -->
        <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
        <!-- 待确认-->
        <el-tab-pane :label="$t('message.toBeConfirmed') + `(${tabs[1].num})`" name="1"></el-tab-pane>
        <!--  已确认-->
        <el-tab-pane :label="$t('message.confirmed')" name="2"></el-tab-pane>
        <!--  已删除-->
        <!-- <el-tab-pane :label="$t('message.Deleted')" name="-1"></el-tab-pane> -->
      </el-tabs>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 初始时间 -->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.CStime')"
              default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <!-- 结束日期 -->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
              default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <!-- 物流号 -->
          <div class="item">
            <el-input v-model="datas.express_no" :placeholder="$t('message.logisticsNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 交易号 -->
          <div class="item">
            <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>

          <!-- 订单号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 客户ID -->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable
              onfocus="this.select()"></el-input>
          </div>
        </div>
        <div class="row">
          <!-- 人员范围 -->
          <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!--  全部人员-->
            <el-select v-model="datas.admin_id" :placeholder="$t('message.allPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button>
        </div>
        <!-- 操作 -->
        <div class="operation">
          <!-- 删除 -->
          <el-button type="primary" class="dark" @click="toDiscardDelete" v-if="isAuth(368)">
            {{ $t("message.delete") }}
          </el-button>
          <!-- 修改 -->
          <el-button type="primary" class="primary" @click="edit" v-if="isAuth(367)">
            {{ $t("message.edit") }}
          </el-button>
          <!-- 确认 -->
          <el-button type="primary" @click="toDiscardConfirm" v-if="isAuth(369)">
            {{ $t("message.ok") }}
          </el-button>
        </div>
      </div>

      <!-- 列表 -->
      <div class="table" v-if="show">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection" size="small">
          <el-table-column align="center" label="NO" width="45" prop="rowNumber" fixed="left">
          </el-table-column>
          <el-table-column type="selection" width="45" align="center" fixed="left" label="选择">

          </el-table-column>
          <!-- 申请人 -->
          <el-table-column align="center" :label="$t('message.theApplicant')" prop="created_admin.realname">
          </el-table-column>
          <!-- 时间 -->
          <el-table-column align="center" :label="$t('message.times')" prop="created_at" width="165px">
            <template slot-scope="scope">
              <div class="template">
                <p>
                  始 ： <span>{{ scope.row.created_at }}</span>
                </p>
                <p>
                  终 ： <span>{{ scope.row.complete_at }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 库位 -->
          <el-table-column align="center" :label="$t('message.location')" width="100px">
            <template slot-scope="scope">
              <p>{{ scope.row.grid_number.split("】-")[0] }}】-</p>
              <p style="color: #fa5058">
                {{ scope.row.grid_number.split("】-")[1] }}
              </p>
            </template>
          </el-table-column>
          <!-- 装箱信息 -->
          <el-table-column align="center" :label="$t('message.packingInformation')" width="200">
            <template slot-scope="scope">
              <p v-for="(items, indexs) in scope.row.order_box" :key="indexs">
                {{ items.order_sn }}-
                <span style="color: #fa5058">{{ items.box_no }}</span>
              </p>
            </template>
          </el-table-column>

          <!-- 订单编号 -->
          <el-table-column align="center" :label="$t('message.orderNumber')" width="140px">
            <template slot-scope="scope">
              <div v-if="scope.row.order_purchase != null">
                <p>
                  <router-link :to="'/orderPaymentDetail?order_sn=' +
                    scope.row.order_purchase.order_sn
                    " target="_blank" style="color: #fa5058">{{ scope.row.order_purchase.order_sn }}</router-link>
                </p>
                <p>{{ scope.row.order_purchase.order.user.realname }}</p>
              </div>
            </template>
          </el-table-column>

          <!-- 番号 -->
          <el-table-column align="center" :label="$t('message.mash')" prop="order_purchase.order_detail.sorting"
            width="50">
          </el-table-column>

          <!-- 图片 -->
          <el-table-column align="center" :label="$t('message.picture')" prop="floor">
            <template slot-scope="scope">
              <div v-if="scope.row.order_purchase != null">
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${scope.row.order_purchase.order_detail.goods_id}.html`"
                    target="_blank" slot="reference">
                    <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 60px; height: 60px" />
                  </a>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <!-- 商品属性 -->
          <el-table-column align="center" :label="$t('message.commodityAttribute')">
            <template slot-scope="scope">
              <div class="template" v-if="scope.row.order_purchase != null">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 交易号/物流号 -->
          <el-table-column align="center" :label="$t('message.transactionNumberLogisticsNumber')" width="180px">
            <template slot-scope="scope">
              <div class="template" v-if="scope.row.order_purchase != null">
                <p>JY：{{ scope.row.order_purchase.purchase_no }}</p>
                <p v-for="(item, index) in scope.row.order_purchase
                  .order_purchase_express" :key="index">
                  WL{{ index + 1 }}：{{ item.express_no }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 数量 -->
          <el-table-column align="center" :label="$t('message.number')">
            <template slot-scope="scope">
              <div class="template">
                <div class="template">
                  <!-- 库位数 -->
                  <p>
                    {{ $t("message.numberOfLibraryPosition") }}:{{
                      scope.row.grid_stock
                    }}
                  </p>
                  <!-- 废弃数 -->
                  <p>{{ $t("message.numberOfWaste") }}:{{ scope.row.num }}</p>
                  <!-- 实有数 -->
                  <p>
                    {{ $t("message.numberOfActualNumbers") }}:{{
                      scope.row.real_num
                    }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 单价(元) -->
          <el-table-column align="center" :label="$t('message.unitPrice') + '.元'"
            prop="order_purchase.order_detail.confirm_price">
          </el-table-column>
          <!-- 客户联系截图 -->
          <el-table-column align="center" :label="$t('message.customerScreenshots')" width="130px">
            <template slot-scope="scope">
              <el-image class="img" :src="img" v-for="(img, imgs) in scope.row.images" :key="imgs" v-show="img"
                :preview-src-list="scope.row.images">
              </el-image>
            </template>
          </el-table-column>
          <!-- 申请原因备注 -->
          <el-table-column align="center" :label="$t('message.applicationReasonRemarks')" width="120px">
            <template slot-scope="scope">
              {{ scope.row.reason }}
            </template>
          </el-table-column>
          <!-- 确认人 -->
          <el-table-column align="center" :label="$t('message.affirmName')" prop="rowNumber" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.confirm_admin"></span>
            </template>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column align="center" :label="$t('message.status')" prop="status_name" width="100">
            <template slot-scope="scope">
              <span :style="{
                color: scope.row.status_name == '已申请' ? '#fa5058' : '',
              }">{{ scope.row.status_name }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 商品废弃 -->
    <wasteGoods v-if="wasteGoodsDialogVisible" :list="selectList" :type="'edit'" />
  </div>
</template>
<script>
import wasteGoods from "../components/wasteGoods";
export default {
  components: {
    wasteGoods,
  },
  data() {
    return {
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 },],
      show: false,
      datas: { status: "" },
      val: "", //时间类型
      startDate: "", //开始时间
      dateClosed: "", //结束时间
      timeOption: [
        { value: 1, label: "入金时间" },
        { value: 2, label: "入库时间" },
        { value: 3, label: "上架完了" },
      ],
      userList: [],
      tableData: [],
      total: 0,
      selectList: [],
      wasteGoodsDialogVisible: false, //商品废弃
      remarkDialogVisible: false, //商品备注
    };
  },
  created() {
    this.toDiscardList();
    this.wmsToDiscardListNum()
  },
  methods: {
    // 申请废弃列表数量统计
    wmsToDiscardListNum() {
      this.$api.tabTotalApi.wmsToDiscardListNum().then(res => {
        this.tabs = res.data
      })
    },
    // 常规,辅料,备品
    toDiscardList() {
      this.show = false;
      this.$api.warehouseApi.toDiscardList(this.datas).then((res) => {
        res.data.data.forEach((item) => { });
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },

    getIndex(i) {
      this.datas.shelf_type = i;
      this.toDiscardList();
    },
    // 区别请求接口
    handleClick() {
      this.datas.page = 1;
      this.toDiscardList();
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.admin_id = "";
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.toDiscardList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.toDiscardList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.toDiscardList();
    },
    // 重置
    reset() {
      this.startDate = "";
      this.dateClosed = "";
      this.datas = {
        page: 1,
        pageSize: 10,
        status: "",
        express_no: "",
        purchase_no: "",

        order_sn: "",
        user_id: "",
        dateStart: "",
        dateEnd: "",
      };
      this.$refs.cascader.orgId = [];
      this.userList = [];
      this.val = "";
      this.$forceUpdate();
      this.toDiscardList();
    },

    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 废弃修改
    edit() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.wasteGoodsDialogVisible = true;
    },

    //删除
    toDiscardDelete() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));

      let datas = {
        ids: [],
      };
      this.selectList.forEach((item) => {
        datas.ids.push(item.id);
      });
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.warehouseApi.toDiscardDelete(datas).then((res) => {
            this.$message.success(res.msg);
            this.toDiscardList();
            this.wmsToDiscardListNum()
          });
        })
        .catch(() => { });
    },
    //确认
    toDiscardConfirm() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));

      let datas = {
        ids: [],
      };
      this.selectList.forEach((item) => {
        datas.ids.push(item.id);
      });
      this.$confirm(
        this.$t("message.isTheApprovalConfirmed"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.warehouseApi.toDiscardConfirm(datas).then((res) => {
            this.$message.success(res.msg);
            this.toDiscardList();
            this.wmsToDiscardListNum()
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped>
.nav {
  display: flex;
  margin-bottom: 24px;

  .item {
    width: 160px;
    height: 48px;
    line-height: 48px;
    border: 2px solid #b4272d;
    color: #b4272d;
    font-size: 18px;
    text-align: center;
    border-right: 0;

    &:nth-child(1) {
      border-radius: 4px 0px 0px 5px;
    }

    &:nth-last-child(1) {
      border: 2px solid #b4272d;
      border-radius: 0px 4px 5px 0px;
    }

    cursor: pointer;
  }

  .index {
    background-color: #b4272d;
    color: #fff;
  }
}

.search {
  margin-top: 10px;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 180px;
      margin-right: 24px;
    }

    /deep/.el-date-editor {
      width: 100%;

      .el-input__inner {
        padding-right: 0;
      }
    }
  }
}

.operation {
  position: absolute;
  bottom: 0;
  right: 0;

  text-align: right;
}

.template {
  width: 100%;
  text-align: left;
}

.img {
  width: 48px;
  height: 48px;
  margin: 0 5px 5px 0;
  cursor: pointer;

  &:nth-child(2n) {
    margin-right: 0;
  }
}
</style>
